module.exports = __webpack_public_path__ + "media/components/src/assets/images/embedded_parts/tel1-c0ab775329db6eb25a139bcbb77a7240.png";